<!--
 * @Description: 日程会场列表页
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-06-23 12:25:55
 * @LastEditors: 山淑兰
 -->
<template>
    <div class="roomlist">
        <div class="loading" v-if="loading">
            <van-loading color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
        </div>
        <div>
            <template v-if="$i18n.locale === 'zh-CN'">
                <ul class="meetinglist" v-for="(item,index) in datas" :key="item.roomid">
                    <li>
                        <div class="meeting-top">
                            <div class="meeting-info">
                                <div class="meeting-add">
                                    <van-cell :title="item.roomname" class="meetingTitle" />
                                </div>
                                <div class="meeting-time">
                                    <van-cell :value="item.prodate + ' ' +item.starttime + '-' + item.endtime" class="forumDate-time" />
                                </div>
                                <div class="meeting-title">
                                    {{ item.roomtitle }}
                                </div>
                            </div>
                            <div class="meeting-icon" v-if="item.roomurl!=null">
                                <a :href="item.roomurl" target="_top">
                                    <p><img src="../../../assets/creame3.png">
                                        观看直播</p>
                                </a>
                            </div>
                        </div>
                        <div class="meeting-arrow" :class="{'arrows':item.dataNext}">
                            <van-icon name="arrow" @click="toLinkLists( index, item.roomid, item.dateid)" />
                        </div>
                    </li>
                    <div class="loading" v-if="item.loading">
                        <van-loading color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
                    </div>
                    <ul class="meetinglists" v-if="item.dataNext">
                        <li v-for="(items, indexs) in item.dataNextDatas" 
                            v-if="item.dataNextDatasYes"
                            :key="indexs" :id="`top${indexs}`">
                            <div class="meeting-infos meeting-infos-zhu">
                                <div class="meeting-times">
                                    {{ items.startime }}~{{ items.endtime }}
                                </div>
                                <div class="meeting-nextDatas">
                                    <ul v-if="items.exData.length>0">
                                        <div class="talker-topic" v-html="nToBr(items.topic )"> </div>
                                        <li v-for="(i, j) in items.exData" :key="j">
                                            <div class="talker-name">
                                                <p>
                                                    {{ i.rolename }}
                                                   <!-- <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
                                                        {{s}}
                                                    </span> -->
                                                    <div class="talker-name-p"
                                                        v-for="(s, k) in i.exname" 
                                                        :key="k" 
                                                        @click="todetails(i.exid[k])">
                                                        <p v-html="nToBr(s)"></p>
                                                        <p v-if="i.excompany[k]!=null&&i.excompany[k]!=''"  v-html="nToBr(i.excompany[k])"></p>
                                                    </div> 
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                    <ul v-else>
                                        <li>
                                            <div class="talker-name">
                                                <span v-html="nToBr(items.topic)"></span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <ul class="meetinglists" v-if="items.children.length>0">
                                <li v-for="(itemss, indexss) in items.children" :key="indexss">
                                    <div class="meeting-infos">
                                        <div class="meeting-times">
                                            {{ itemss.startime }}~{{ itemss.endtime }}
                                        </div>
                                        <div class="meeting-nextDatas">
                                            <ul v-if="itemss.exData.length>0">
                                                <div class="talker-topic" v-html="nToBr(itemss.topic)"></div>
                                                <li v-for="(i, j) in itemss.exData" :key="j">
                                                    <div class="talker-name">
                                                        <p>
                                                            {{ i.rolename }}
                                                           <!-- <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
                                                                {{s}}
                                                            </span> -->
                                                            <div class="talker-name-p"
                                                                v-for="(s, k) in i.exname" 
                                                                :key="k" 
                                                                @click="todetails(i.exid[k])">
                                                                <p v-html="nToBr(s)"></p>
                                                                <p v-if="i.excompany[k]!=null&&i.excompany[k]!=''" v-html="nToBr(i.excompany[k])"></p>
                                                            </div> 
                                                        </p>
                                                    </div>
                                                </li>
                                            </ul>
                                            <ul v-else>
                                                <li>
                                                    <div class="talker-name">
                                                        <span v-html="nToBr(itemss.topic)"></span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </li>
                        <li v-if="!item.dataNextDatasYes" style="text-align: center;">暂无数据</li>
                    </ul>
                </ul>
            </template>
			<template v-else>
				<ul class="meetinglist" v-for="(item,index) in datas" :key="item.roomid">
				    <li>
				        <div class="meeting-top">
				            <div class="meeting-info">
				                <div class="meeting-add">
				                    <van-cell :title="item.roomenname!=null&&item.roomenname!=''?item.roomenname:item.roomname" class="meetingTitle" />
				                </div>
				                <div class="meeting-time">
				                    <van-cell :value="item.prodate + ' ' +item.starttime + '-' + item.endtime" class="forumDate-time" />
				                </div>
				                <div class="meeting-title">
				                    {{ item.roomentitle!=null && item.roomentitle!=''?item.roomentitle:item.roomtitle }}
				                </div>
				            </div>
				            <div class="meeting-icon" v-if="item.roomurl!=null">
				                <a :href="item.roomurl" target="_top">
				                    <p><img src="../../../assets/creame3.png">
				                        观看直播</p>
				                </a>
				            </div>
				        </div>
				        <div class="meeting-arrow" :class="{'arrows':item.dataNext}">
				            <van-icon name="arrow" @click="toLinkLists(index, item.roomid, item.dateid)" />
				        </div>
				    </li>
				    <div class="loading" v-if="item.loading">
				        <van-loading color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
				    </div>
				    <ul class="meetinglists" v-if="item.dataNext">
				        <li v-for="(items, indexs) in item.dataNextDatas" 
				            v-if="item.dataNextDatasYes"
				            :key="indexs" :id="`top${indexs}`">
				            <div class="meeting-infos meeting-infos-zhu">
				                <div class="meeting-times">
				                    {{ items.startime }}~{{ items.endtime }}
				                </div>
				                <div class="meeting-nextDatas">
				                    <ul v-if="items.exData.length>0">
				                        <div class="talker-topic" v-html="items.entopic!=null&&items.entopic!=''?nToBr(items.entopic):nToBr(items.topic)"></div>
				                        <li v-for="(i, j) in items.exData" :key="j">
				                            <div class="talker-name">
				                                <p>
				                                    {{ i.rolename }}
				                                   <!-- <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
				                                        {{i.exenname[k]!=''&&i.exenname[k]!=null?i.exenname[k]:s}}
				                                    </span> -->
				                                    <div class="talker-name-p"
				                                        v-for="(s, k) in i.exname" 
				                                        :key="k" 
				                                        @click="todetails(i.exid[k])">
                                                        <p v-html="i.exenname[k]!=''&&i.exenname[k]!=null?nToBr(i.exenname[k]):nToBr(s)"></p>
				                                        <p v-if="i.excompany[k]!=null&&i.excompany[k]!=''"
                                                            v-html="i.exencompany[k]!=''&&i.exencompany[k]!=null?nToBr(i.exencompany[k]):nToBr(i.excompany[k])">
                                                        </p>
				                                    </div> 
				                                </p>
				                            </div>
				                        </li>
				                    </ul>
				                    <ul v-else>
				                        <li>
				                            <div class="talker-name">
				                                <span v-html="items.entopic!=null&&items.entopic!=''?nToBr(items.entopic):nToBr(items.topic)"></span>
				                            </div>
				                        </li>
				                    </ul>
				                </div>
				            </div>
				            <ul class="meetinglists" v-if="items.children.length>0">
				                <li v-for="(itemss, indexss) in items.children" :key="indexss">
				                    <div class="meeting-infos">
				                        <div class="meeting-times">
				                            {{ itemss.startime }}~{{ itemss.endtime }}
				                        </div>
				                        <div class="meeting-nextDatas">
				                            <ul v-if="itemss.exData.length>0">
				                                <div class="talker-topic" v-html="itemss.entopic!=null&&itemss.entopic!=''?nToBr(itemss.entopic):nToBr(itemss.topic)"></div>
				                                <li v-for="(i, j) in itemss.exData" :key="j">
				                                    <div class="talker-name">
				                                        <p>
				                                            {{ i.rolename }}
				                                          <!--  <span v-if="i.exname.length>3" v-for="(s, k) in i.exname" :key="k" @click="todetails(i.exid[k])">
				                                                {{i.exenname[k]!=''&&i.exenname[k]!=null?i.exenname[k]:s}}
				                                            </span> -->
				                                            <div class="talker-name-p"
				                                                v-for="(s, k) in i.exname" 
				                                                :key="k" 
				                                                @click="todetails(i.exid[k])">
																<p v-html="i.exenname[k]!=''&&i.exenname[k]!=null?nToBr(i.exenname[k]):nToBr(s)"></p>
                                                                <p v-if="i.excompany[k]!=null&&i.excompany[k]!=''" 
                                                                    v-html="i.exencompany[k]!=''&&i.exencompany[k]!=null?nToBr(i.exencompany[k]):nToBr(i.excompany[k])">
                                                                </p>
				                                            </div>  
				                                        </p>
				                                    </div>
				                                </li>
				                            </ul>
				                            <ul v-else>
				                                <li>
				                                    <div class="talker-name">
				                                        <span v-html="items.entopic!=null&&items.entopic!=''?nToBr(items.entopic):nToBr(items.topic)"></span>
                                                    </div>
				                                </li>
				                            </ul>
				                        </div>
				                    </div>
				                </li>
				            </ul>
				        </li>
				        <li v-if="!item.dataNextDatasYes" style="text-align: center;">no datas</li>
				    </ul>
				</ul>
			</template>
            <div class="modal" v-if="modalShow">
             <!--  <div class="loading" v-if="loading1">
                <van-loading
                  type="spinner"
                  color="#3b82f6"
                  vertical
                  size="30px"
                  text-size="16px"
                  >加载中...</van-loading
                >
              </div>
                <div class="details-conss">
                    <div class="details-head">
                        <div class="guest-headimg" @click="viewPhoto()">
                            <img :src="this.dataList.photo || this.defaultHeadImg" alt />
                        </div>
                        <div class="guest-top">
                            <div class="guest-intro">
                                <div class="guest-name">
                                    <span>{{ this.dataList.cnname }}</span>
                                </div>
                                <div class="host">{{ this.dataList.cncompany }}</div>
                            </div>
                        </div>
                        <div class="guest-close" @click="closeGuest">
                          <img src="../../../assets/h-close.png">
                        </div>
                    </div>
                    <ul class="details-tab">
                        <li :class="{'active':tabShow1}" @click="getIntro()">{{ $t('meeting.details.guestsIntroductionTitle') }}</li>
                        <li :class="{'active':tabShow2}" @click="getdetails()">讲者日程({{list.length}})</li>
                    </ul>
                    <div id="guestIntroduction-con" v-if="tabShow1">
                        <p v-html="this.dataList.cnintroduction"></p>
                    </div>
                    <div class="details-main" v-if="tabShow2">
                        <div v-show="show == 'tasks'" v-for="(item, index) in list" :key="index">
                            <div class="details-main-head">
                                <van-cell :title="item[0].createdTime" icon="send-gift-o" class="details-main-head-date" />
                            </div>
                            <van-cell class="details-main-con" v-for="(i, id) in item" :key="id">
                                <div class="meeting-list" v-if="i.url!=null">
                                    <div class="meeting-left">
                                        <van-cell icon="underway-o" class="major-title">
                                            {{ i.startTime + '-' + i.endTime }}
                                        </van-cell>
                                        <a v-if="i.roomTitle || i.roomName">
                                            <van-cell icon="orders-o" class="major-title" :class="{ _link: i.url }">{{ i.roomTitle }}</van-cell>
                                        </a>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
                                            i.roleName
                                            }}</van-cell>
                                    </div>
                                    <div class="meeting-icon">
                                        <a :href="i.url" target="_top">
                                            <p><img src="../../../assets/creame3.png">
                                                观看直播</p>
                                        </a>
                                    </div>
                                </div>
                                <div class="meeting-list" v-if="i.url==null" @click="goMeeting($event,i.dateid,i.roomid)">
                                    <div class="meeting-left">
                                        <van-cell icon="underway-o" class="major-title">
                                            {{ i.startTime + '-' + i.endTime }} {{ i.topic }}
                                        </van-cell>
                                        <a v-if="i.roomTitle || i.roomName">
                                            <van-cell icon="location-o" class="major-title" :class="{ _link: i.url }">{{ i.roomTitle }}</van-cell>
                                            <van-cell icon="orders-o" class="major-title" :class="{ _link: i.url }">{{i.roomName }}</van-cell>
                                        </a>
                                        <van-cell class="major-title" icon="user-o" v-if="i.roleName">{{
                                            i.roleName
                                            }}</van-cell>
                                    </div>
                                    <div class="meeting-icons">
                                        <img class="arrow" src="../../../assets/arrow-r.png">
                                    </div>
                                </div>
                            </van-cell>
                        </div>
                    </div>
                </div> -->
                <div class="details-conss">
                    <DetailsNews :exid="exid" :introStatus="introShow"  @func="closeGuest"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DetailsNews from './details-news.vue';
export default {
    name: 'place',
	props: ['introShow'],
    components: {
        DetailsNews
    },

    data() {
        return {
            loading: false,
            loading1: false,
            datas: [],
            m: '',
            dateid: 0,
            roomid: 0,
            search: '',
            modalShow: false,
			dateids: 0,
			roomids: 0,
			language: 0, //0中文，1英文
        }
    },
    watch: {
        $route(to, from) {
            if (to.query.dateid != from.query.dateid && to.query.dateid) {
                this.dateid = to.query.dateid
                this.init()
            }
        },
    },
    created() {
		this.language = this.$route.query.language
        if (this.$route.query) {
            this.dateid = this.$route.query.dateid
            this.init()
        }
    },
    methods: {
        async init() {
            try {
                this.loading = true
                const {
                    m,
                    dateid = this.dateid,
                    roomid = this.roomid,
                    search = this.search,
                } = this.$route.query //获得路由的参数
                this.m = m

                const _params = Object.assign({ m, dateid, roomid },
                    search ? { search } : {}
                ) //search 是空字符串 为false 有值是true

                const res = await this.$http.initScheduleInfo(_params)
                this.$emit('searchDatas', res.childens)
                console.log(res.childens)
                this.datas = res.RoomDateEntityList
				this.dateids = res.RoomDateEntityList[0].dateid
				this.roomids = res.RoomDateEntityList[0].roomid
				console.log(this.datas)
				console.log(this.dateids,this.roomids)
                this.datas.forEach(item => {
                    this.$set(item, 'dataNext', false)
                    this.$set(item, 'dataNextDatas', '')
                    this.$set(item, 'loading', false)
                    this.$set(item, 'dataNextDatasYes', true)
					console.log(this.language)
					if (this.language == 1){
						if(item.prodate.indexOf('月')!=-1){
							item.prodate = item.prodate.replace('月','.')
						}
						if(item.prodate.indexOf('日')!=-1){
							item.prodate = item.prodate.replace('日',' ')
						}
					}
                })
				this.toLinkLists(0,this.roomids,this.dateids)
                console.log('会场列表数据', this.datas)

                this.loading = false
            } catch (error) {
                console.error(error)
            }

            // this.$toast.clear(false); //关闭加载动画
        },

        /**
         * @description 进入到子路由 封装的方法
         * @param {Objcet} params 路由需要的参数
         */
        toLinkList(roomid, dateid) {
            const params = {
                roomid: roomid,
                dateid: dateid,
            }
            const { m } = this.$route.query
            this.$router.push({
                path: 'scheduleList',
                query: { m, ...params },
            })
        },


        async inits(_params, index) {
            try {
                this.datas[index].dataNext = false
                this.datas[index].loading = true
                const res = await this.$http.initScheduleInfo(_params)
                //this.datas = res.RoomDateEntityList
                //this.datas[index].dataNextDatas = res.RoomDateEntity
                this.datas[index].loading = false
                let _list
                if (res.DateListEntity != null && res.DateListEntity.length > 0) {
                    _list =
                        res.DateListEntity[0].programListEntity[0].programs.programList
                    this.num = 0
                    const _data = this.dealData(0, _list)
                    // console.log(_data, '处理后的日程数据')
                    this.datas[index].dataNextDatas = this.getSubAgendaData(_data)
                    
                    this.datas[index].dataNext = true
                    this.datas[index].dataNextDatasYes = true

                    for (let i = 0; i < _data.length; i++) {
                        this.datas[index].dataNextDatas[i].children = this.getSubAgendaData(_data[i].children)
                    }
                }else{
                    this.datas[index].dataNextDatas = '暂无数据'
                    this.datas[index].dataNext = true
                    this.datas[index].dataNextDatasYes = false
                }

                console.log(this.datas)


            } catch (error) {
                console.error(error)
            }
        },
        convertTime(time) {
            let end = time.split('(')[1].split(')')[0]
            // 将时间戳转时间格式
            let date = new Date(Number(end))
            let h = date.getHours()
            h = h < 10 ? '0' + h : h
            let m = date.getMinutes()
            m = m < 10 ? '0' + m : m
            return h + ':' + m
        },
        dealData(firstId, data) {
            let _temp = []
            for (let i = 0; i < data.length; i++) {
                if (data[i].upproid === firstId) {
                    this.num++
                    _temp.push(data.splice(i, 1)[0])
                    i--
                }
            }
            for (let i = 0; i < _temp.length; i++) {
                _temp[i].children = this.dealData(_temp[i].proid, data)
            }
            return _temp
        },
        getSubAgendaData(data) {
            let SubAgendaData = []
            for (let k = 0; k < data.length; k++) {
                let endtime = data[k].endtime,
                    startime = data[k].starttime,
                    children = data[k].children,
                    exData = [],
                    exenname = [],
                    exid = [],
                    roleenname = ''
                let exnameId = []
                for (let s = 0; s < data[k].expertList.length; s++) {
                    exid.push(data[k].expertList[s].exid)

                    exenname.push(data[k].expertList[s].exenname)
                    roleenname = data[k].expertList[s].exrolemodel.roleenname
                    exnameId.push({
                        exname: data[k].expertList[s].exname,
                        exid: data[k].expertList[s].exid,
                        excompany: data[k].expertList[s].excompany,
                    })

                    exData = this.filterRolename(data[k].expertList)
                }

                SubAgendaData.push({
                    children,
                    startime,
                    endtime,
                    topic: data[k].topic,

                    exid,
                    exData,
                    //英文数据 ----
                    entopic: data[k].entopic,
                    exenname,
                    roleenname,
                })
            }
            return SubAgendaData
        },
        filterRolename(data) {
            let _rolenameList = [], //已去重rolename
                _rolename = [] // 所有rolename

            //去掉重复的身份（rolename）
            for (let i in data) {
                _rolename.push(data[i].exrolemodel.rolename)
                let _indexof = _rolenameList.indexOf(_rolename[i])
                if (_indexof == -1) {
                    _rolenameList.push(data[i].exrolemodel.rolename)
                }
            }
            let _identityList = [] //去重后的身份和姓名总数据
            _rolenameList.forEach((item) => {
                let _identity = { rolename: '', exname: [], exid: [], excompany: [], exenname: [], exencompany: []}
                let _exname = [], //同一身份的嘉宾姓名
                    _exid = [],
                    _excompany = [],
					_exenname = [],
					_exencompany = [];
                for (let n in data) {
                    if (item === data[n].exrolemodel.rolename) {
                        _exname.push(data[n].exname)
                        _identity.rolename = item
                        _identity.exname = _exname
                        _exid.push(data[n].exid)
                        _identity.exid = _exid
                        _excompany.push(data[n].excompany)
                        _identity.excompany = _excompany
						_exenname.push(data[n].exenname)
						_identity.exenname = _exenname
						_exencompany.push(data[n].exencompany)
						_identity.exencompany = _exencompany
                    }
                }
                _identityList.push(_identity)
            })

            return _identityList
        },
        toLinkLists(index, roomids, dateids) {
            //this.datas[index].loading = !this.datas[index].loading
            this.datas[index].dataNext = !this.datas[index].dataNext
            if (this.datas[index].dataNextDatas == null || this.datas[index].dataNextDatas == '') {
                const dateid = dateids,
                    roomid = roomids,
                    search = this.search,
                    m = this.m;

                const _params = Object.assign({ m, dateid, roomid },
                    search ? { search } : {}
                ) //search 是空字符串 为false 有值是true

                this.inits(_params, index)
            }else{
                this.datas[index].loading = false
            }
            
        },
        todetails(param) {
            // const exid = param
            // this.$router.push({
            //   path: '/meeting/details',
            //   query: { m: this.m, exid},
            // })
            // this.dataList = []
            // this.list = {}
            //this.detailsInit(exid)
            this.modalShow = true
            this.exid = param
        },
        // formatTime(val) {
        //     let et = val.split('(')
        //     let end = et[1].split(')')[0]
        //     let endtime = Number(end)
        //     let date = new Date(endtime)
        //     let h = date.getHours()
        //     h = h < 10 ? '0' + h : h
        //     let m = date.getMinutes()
        //     m = m < 10 ? '0' + m : m
        //     return h + ':' + m
        // },
        // formatDate(val) {
        //     let et = val.split('(')
        //     let end = et[1].split(')')[0]
        //     let date = new Date(Number(end))
        //     let month = date.getMonth() + 1
        //     let day = date.getDate()
        //     return month + '-' + day
        // },
        // async detailsInit(exid) {
        //     try {
        //         this.loading1 = true
        //         const { m } = this.$route.query
        //         const _params = { m, exid }
        //         const PopupData = await this.$http.initScheduleInfo({ m })
        //         const res = await this.$http.initGuestInfo(_params)

        //         // 头像卡片部分
        //         this.dataList = res.expert
        //         if (this.dataList.cnintroduction) {
        //             this.dataList.cnintroduction = this.dataList.cnintroduction.replace(
        //                 /\n/g,
        //                 '<br>'
        //             )
        //         }
        //         if (this.dataList.enintroduction) {
        //             this.dataList.enintroduction = this.dataList.enintroduction.replace(
        //                 /\n/g,
        //                 '<br>'
        //             )
        //         }
        //         console.log(this.dataList)

        //         let _list = []
        //         res.DateListEntity.map((item) => {
        //             let _k = []
        //             for (let i in item.programListEntity) {
        //                 let _D = item.programListEntity[i]
        //                 let { programList } = _D.programs
        //                 for (let j in programList) {
        //                     let _S = programList[j]
        //                     console.log(_S)
        //                     programList[j] = {
        //                         url: _S.programRoom.url,
        //                         //中文
        //                         createdTime: this.formatDate(_S.programDate.prodate),
        //                         startTime: this.formatTime(_S.starttime),
        //                         endTime: this.formatTime(_S.endtime),
        //                         total: item.ProgramCount, //总数量
        //                         pohto: res.expert.photo, //头像路径
        //                         topic: _S.topic,
        //                         roomName: _S.programRoom.roomname,
        //                         roomTitle: _S.programRoom.roomtitle,
        //                         roleName: _S.expertList[0].exrolemodel.rolename,
        //                         dateid: _S.dateid,
        //                         roomid: _S.roomid,
        //                         //英文
        //                         entopic: _S.entopic,
        //                         roomEnName: _S.programRoom.roomenname,
        //                         roomEnTitle: _S.programRoom.roomentitle,
        //                         roleEnName: _S.expertList[0].exrolemodel.roleenname,
        //                     }
        //                     _k.push(programList[j])
        //                 }
        //             }

        //             _list.push(_k)
        //         })

        //         this.list = _list
        //         console.log(this.list)
        //         this.loading1 = false
        //     } catch (err) {
        //         console.log(err)
        //     }
        // },
        goMeeting(e, dateid, roomid) {
            const params = {
                m: this.$route.query.m,
                roomid: roomid,
                dateid: dateid
            }
            this.$router.push({
                path: 'scheduleList',
                query: params,
            })
        },
        getIntro() {
            this.tabShow1 = true
            this.tabShow2 = false
        },
        getdetails() {
            this.tabShow1 = false
            this.tabShow2 = true
        },
        closeGuest(){
          this.modalShow = false
        },
        //点击查看头像
        viewPhoto() {
          if (this.list.src) {
            ImagePreview({
              images: [this.list.src],
              startPosition: 0,
              onClose() {
                // do something
              },
              showIndex: false,
              closeOnPopstate: true,
            })
          }
        },
        nToBr (str){
            if( str ){
                return str.replace(/\\n/g,'<br/>');
            }else{
                return str
            }
           
        },
    },
}
</script>
<style lang="scss" scoped>
.roomlist {
    margin-bottom: 80px;
    font-size: 26px;
    line-height: 1.5;
    padding: 0 20px 20px;

    .meetinglist {
        background: #fff;
        margin-top: 20px;
        padding: 20px;
        position: relative;
        -webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        border-radius: 12px;

        li {
            .meeting-top {
                width: 100%;
            }

            .meeting-date {
                width: 160px;
                padding: 10px 0 0 0;
                font-weight: bold;
                display: flex;
                align-items: flex-start;
                flex-direction: column;
                justify-content: flex-end;

                p {
                    font-size: 42px;
                    color: #1e293b;
                }

                p:last-child {
                    font-size: 64px;
                    color: #64748b;
                    margin-top: 5px;
                }
            }

            .meeting-info {
                flex: 1;
                .meeting-title {
                    margin: 20px 0 5px;
                    font-size: 30px;
                }

                .meeting-time {
                    margin-top: 3px;
					font-size: 29px;
                }

                .van-cell {
                    padding: 0;
                    font-size: 29px;
                    line-height: 1.5;
                    color: #64748b;

                    .van-cell__left-icon {
                        line-height: 40px;
                        font-size: 28px;
                    }

                    .van-cell__value--alone {
                        color: #64748b;
                    }
                }
            }

            .meeting-icon {
                position: absolute;
                right: 0;
                top: 30px;
                width: 160px;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                background: #3b82f6;
                padding: 10px 0;
                border-radius: 50px 0 0 50px;

                a {
                    color: #fff;
                    display: block;
                    text-align: center;
                }

                img {
                    width: 30px;
                    vertical-align: -4px;
                }

                p {
                    font-size: 12px;
                }
            }

            .meeting-arrow {
                width: 100%;
                text-align: center;

                .van-icon {
                    font-size: 40px;
                    transform: rotate(90deg);
                    color: #64748b;
                }
            }

            .arrows {
                .van-icon {
                    font-size: 40px;
                    transform: rotate(-90deg);
                    color: #64748b;
                }
            }
        }
    }

    .meetinglists {
        .meeting-infos {
            display: flex;
            background: #f8fafc;
            margin: 20px 0;
            padding: 10px 5px;

            .meeting-times {
                width: 180px;
                margin: 5px 0;
            }

            .meeting-nextDatas {
                flex: 1;

                li {
                    margin: 5px 0 15px;
                }

                .talker-name {
                    color: #1e293b;
                    p {
                        
                    }
                    .talker-name-p{
                        color: #3b82f6;
                        margin-bottom: 5px;
                    }
                    span {
                        margin-right: 10px;
                        color: #3b82f6;
                        i{
                            color: #3b82f6;
                        }
                    }
                }
            }
        }

        .meeting-infos-zhu {
            background: #eff6ff;
        }
    }
}

.modal {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 1000;
    .loading{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 10002;
    }
    .details-conss {
        background: #fff;
        // padding: 20px 0;
        // -webkit-box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        // box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        margin-bottom: 20px;
        //border-radius: 12px;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 10001;
        transform: translate(-50%, -50%);
        width: 90%;
        height: 80%;
        overflow-y: auto;

        #guestIntroduction-con {
            margin-top: 15px;
            padding: 10px 0;

            >h4 {
                font-size: 26px;
                border-bottom: 1px solid #e2e8f0;
                padding: 16px 20px;
                background: #3b82f6;
                border-radius: 12px 15px 0 0;
                color: #fff;
                margin-bottom: 10px;
            }

            >p {
                padding: 0 20px;
            }
        }
    }

    .details-head {
        position: relative;
        background: #3b82f6;
        display: flex;
        padding: 20px;
        color: #fff;
        .guest-headimg {
            text-align: center;
            margin-right: 20px;
            width: 160px;
            height: 160px;
            border-radius: 160px;

            img {
                width: 100%;
                height: 100%;
                border-radius: 160px;
            }
        }

        .guest-intro {
            margin-top: 20px;
            font-size: 28px;

            .host,
            .guest-name {
                margin-top: 8px;
            }
        }
        .guest-close{
          position: absolute;
          right: 30px;
          top: 30px;
          width: 50px;
          height: 50px;
          background: rgba(255,255,255,1);
          border-radius: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            display: block;
            width: 36px;
            height: 36px;
          }
        }
    }

    .details-tab {
        margin: 30px 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #e2e8f0;
        padding-bottom: 10px;

        li {
            padding: 0 30px;
        }

        li.active {
            position: relative;
            color: #3b82f6;
        }

        li.active:after {
            position: absolute;
            display: block;
            content: '';
            height: 4px;
            left: 40px;
            right: 40px;
            bottom: -10px;
            background: #3b82f6;
        }
    }

    .details-title {
        margin: 20px 10px;
        font-size: 28px;
        color: #1e293b;

        span {
            display: inline-block;
            margin: 0px 18px;
            line-height: 60px;
            height: 60px;
        }

        &>div {
            height: 30%;
            font-size: 28px;

            .synopsis {
                .synopsis-tit {
                    height: 60px;
                    line-height: 60px;
                    background: #e2e8f0;
                    padding-left: 10px;
                }
            }

            .van-icon {
                color: #fff;
            }
        }
    }

    .details-main {

        //padding-bottom: 30px;
        >div {
            background: #fff;
            margin-bottom: 24px;
            // box-shadow: 0 2px 12px rgba(0,0,0,0.04);
            border-bottom: 1px solid #e2e8f0;
        }

        .meeting-list {
            display: flex;
            margin-bottom: 10px;
            padding: 10px 20px 10px 22px;
            position: relative;

            .meeting-left {
                flex: 1
            }

            .meeting-icon {
                position: absolute;
                right: 0;
                top: 20px;
                z-index: 10;
                width: 160px;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                background: #3b82f6;
                padding: 10px 0;
                border-radius: 50px 0 0 50px;

                a {
                    color: #fff;
                    display: block;
                    text-align: center;
                }

                img {
                    width: 30px;
                    vertical-align: -4px;
                }

                p {
                    font-size: 12px;
                }
            }

            .meeting-icons {
                width: 100px;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                a {
                    color: #1e293b;
                    display: block;
                    text-align: center;
                }

                img {
                    width: 90px;
                }

                img.arrow {
                    width: 30%;
                }
            }
        }

        .details-main-head {
            // border-bottom: 1px solid #e2e8f0;
            //padding: 10px 0px;
            display: flex;

            // background: #3b82f6;
            // border-radius: 12px 15px 0 0;
            .details-main-head-date {
                color: #3b82f6;
                padding: 0px 0px 0px 20px;
                font-size: 28px;

                &>.van-icon {
                    font-size: 40px;
                    line-height: 40px;
                }

                &:after {
                    border: none;
                }

                span {
                    line-height: 40px;
                }
            }

            .van-cell {
                background: none;
                color: #e6a23c;
            }

            .details-list-num {
                width: 40px;
                height: 40px;
                font-size: 28px;
                margin-right: 20px;
                border-radius: 12px;
                color: #fff;
                text-align: center;
                line-height: 40px;
            }
        }

        .details-main-con {
            position: relative;
            color: #1e293b;

            // border-bottom: 1px solid #e2e8f0;
            .major-title {
                padding: 8px 0px;
                font-size: 26px;
                color: #1e293b;
                line-height: 36px;

                >i {
                    width: 36px;
                    font-size: 36px;
                    line-height: 36px;
                }

                >div {
                    color: #1e293b;
                }

                &:after {
                    border: 0px;
                }
            }
        }

        .details-main-con.van-cell {
            padding: 0;
        }

        #guestIntroduction-con {
            min-height: 300px;
            margin-top: 20px;

            >h4 {
                font-size: 30px;
                padding-left: 20px;
                height: 60px;
                line-height: 60px;
                border-bottom: 1px solid #e2e8f0;
                padding: 16px 0px;
                display: flex;
                background: #3b82f6;
                border-radius: 12px 15px 0 0;
            }

            >p {
                width: 90%;
                margin: 0 auto;
                padding: 20px 0;
                line-height: 54px;
            }
        }
    }
}
</style>